import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import GolfIcon from './GolfIcon';
import '../styles/clubhouse.css';

export default function MarketingLayout({ eyebrow, title, intro, children }: {
  eyebrow: string;
  title: string;
  intro: string;
  children: React.ReactNode;
}) {
  return <div className="club-landing min-h-screen">
    <header className="club-header">
      <Link to="/" className="club-logo" aria-label="Fairplay home"><GolfIcon name="flag"/><span>Fairplay<small>GOOD MATES. QUESTIONABLE GOLF.</small></span></Link>
      <Link to="/register" className="club-button">Start a fourball <ArrowRight aria-hidden="true"/></Link>
    </header>
    <main className="mx-auto max-w-4xl px-5 py-14 sm:py-20">
      <Link to="/" className="mb-9 inline-flex items-center gap-2 text-sm font-bold text-[#d8bd7d]"><ArrowLeft className="h-4 w-4"/> Back to Fairplay</Link>
      <p className="club-eyebrow">{eyebrow}</p>
      <h1 className="max-w-3xl text-5xl font-black leading-[0.98] tracking-[-0.04em] text-[#f7f1e3] sm:text-7xl">{title}</h1>
      <p className="mt-7 max-w-2xl text-xl leading-relaxed text-[#b9cabc]">{intro}</p>
      <article className="seo-article mt-14">{children}</article>
    </main>
    <footer className="club-footer"><span>© {new Date().getFullYear()} Fairplay · South Africa</span><div><Link to="/how-it-works">How it works</Link><Link to="/golf-side-bets">Golf side bets</Link><a href="mailto:go@b-3data.com">Contact</a><Link to="/terms">Terms</Link><Link to="/privacy">Privacy</Link></div><span>18+ · Bet responsibly</span></footer>
  </div>;
}
